<template>
<p>On this site I want to share the learning resources I used as well as resources I, at least, heard of</p>
  <ul>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
  </ul>
</template>

<script setup lang="ts">
</script>

<style scoped>

</style>